import { createAction, createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface RecordingState {
    hasLastRecording: boolean;
    lastRecordingDate: number | undefined;
}

const initialState: RecordingState = {
    hasLastRecording: false,
    lastRecordingDate: undefined,
};

export const downloadLastRecordAction = createAction('recording/downloadLastRecordAction');
export const updateHasLastRecordAction = createAction('recording/updateHasLastRecordAction');

const recordingSlice = createSlice({
    name: 'recording',
    initialState,
    reducers: {
        setHasLastRecording(state: RecordingState, action: PayloadAction<boolean>) {
            state.hasLastRecording = action.payload;
        },
        setLastRecordingDate(state: RecordingState, action: PayloadAction<number | undefined>) {
            state.lastRecordingDate = action.payload;
        },
    },
});

export const { setHasLastRecording, setLastRecordingDate } = recordingSlice.actions;

export const recordingReducer = recordingSlice.reducer;
